module.exports = __webpack_public_path__ + "img/Icon_km-01.49bea6cf.png";